import { Api } from "@/api";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./index.module.scss";
import Button from "../../../common/button";
import { getBacket } from "../../../../redux/action-creaters/cart";
import { showPopup } from "../../../../redux/action-creaters/popup";
import { popupTypes } from "../../../../redux/reducers/popupReducer";

// eslint-disable-next-line import/no-unresolved
import "swiper/css";
import {
  CART_GOALS,
  GOALS,
  reachCartGoal,
  reachGoal,
} from "../../../../utils/tracking";

export default function BuyWithThis({ ids }) {
  const [buyWithThisProduct, setBuyWithThisProduct] = useState([]);

  const getProducts = async (ids) => {
    const products = await Api.product.getBuyWithThis(ids);
    setBuyWithThisProduct(products);
  };

  const products = useMemo(() => {
    return buyWithThisProduct ?? [];
  }, [buyWithThisProduct]);

  useEffect(() => {
    if (ids) {
      getProducts(ids);
    }
  }, [ids]);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  return (
    buyWithThisProduct?.length > 0 && (
      <div>
        <div className={styles.Title}>Дополнительные товары</div>
        <div className={styles.Services}>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={20}
            className="swiper-auto-width"
          >
            {products.map((item) => (
              <SwiperSlide key={`${item.name}`}>
                <a
                  className={styles.Service}
                  key={item.ID}
                  target={"_blank"}
                  rel="noreferrer"
                  href={item.DETAIL_PAGE_URL}
                >
                  <div className={styles.Image}>
                    <img src={item.PHOTO} />
                  </div>
                  <div className={styles.Art}>Артикул: {item.ART}</div>
                  <span className={styles.Name}>{item.NAME}</span>
                  <span className={styles.Price}>{item.PRICE} руб</span>
                  <div className={styles.Buttons}>
                    <Button
                      onClick={async () => {
                        setIsAddingToCart(true);
                        await Api.basket.addToBasket(item.ID);
                        await dispatch(getBacket());
                        await dispatch(showPopup(popupTypes.cart));
                        setIsAddingToCart(false);

                        reachGoal(GOALS.addToCart, user);
                        reachCartGoal(CART_GOALS.addToCart, user);
                      }}
                      label={"Купить"}
                      isLoading={isAddingToCart}
                    />
                    <Button
                      type="outline"
                      label="Заказать в 1 клик"
                      onClick={() => {
                        dispatch(
                          showPopup(popupTypes.buyOneClick, {
                            id: item.ID,
                          }),
                        );
                      }}
                    />
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  );
}
